module.exports = __webpack_public_path__ + "static/media/LogoBareskrim.7b8de545.svg";